export const GET_HIPPA_ASSESSMENT_REQUEST =  'GET_HIPPA_ASSESSMENT_REQUEST';
export const GET_HIPPA_ASSESSMENT_REQUEST_SUCCESS = 'GET_HIPPA_ASSESSMENT_REQUEST_SUCCESS';
export const GET_HIPPA_ASSESSMENT_REQUEST_FAILURE =  'GET_HIPPA_ASSESSMENT_REQUEST_FAILURE';

export const SAVE_ANSWER_REQUEST =  'SAVE_ANSWER_REQUEST';
export const SAVE_ANSWER_REQUEST_SUCCESS = 'SAVE_ANSWER_REQUEST_SUCCESS';
export const SAVE_ANSWER_REQUEST_FAILURE =  'SAVE_ANSWER_REQUEST_FAILURE';